const signatureLogoUrl =
    'https://dentalbilling.com/wp-content/themes/hs-eassist/assets/images/logo-light-mode.svg';

export default signatureLogoUrl;
